import { useAuth } from "../../contexts/auth/useAuth";
import HomeUsers from "./HomeUsers";
import HomeRegister from './HomeRegister';
import { roles } from "../../types/Users";
function Home(){
  const {isRole} = useAuth();

  return (
    <>
    {isRole(roles.PasValider) ?
      <HomeRegister />
    :
      <HomeUsers />
    }
    </>
  )
}
export default Home;